import { useState } from 'react';
import { ProductDTO } from '../../../services/modules/productService';

export const useProductModals = () => {
    const [isFormModalOpen, setFormModalOpen] = useState(false);
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [isBulkDeleteModalOpen, setBulkDeleteModalOpen] = useState(false);
    const [isFilterModalOpen, setFilterModalOpen] = useState(false);
    const [productToEdit, setProductToEdit] = useState<ProductDTO | null>(null);
    const [productToDelete, setProductToDelete] = useState<ProductDTO | null>(null);

    const openCreateModal = () => {
        setProductToEdit(null);
        setFormModalOpen(true);
    };

    const openEditModal = (product: ProductDTO) => {
        setProductToEdit(product);
        setFormModalOpen(true);
    };

    const openDeleteModal = (product: ProductDTO) => {
        setProductToDelete(product);
        setDeleteModalOpen(true);
    };

    const closeModals = () => {
        setFormModalOpen(false);
        setDeleteModalOpen(false);
        setBulkDeleteModalOpen(false);
        setFilterModalOpen(false);
        setProductToEdit(null);
        setProductToDelete(null);
    };

    return {
        isFormModalOpen,
        setFormModalOpen,
        isDeleteModalOpen,
        setDeleteModalOpen,
        isBulkDeleteModalOpen,
        setBulkDeleteModalOpen,
        isFilterModalOpen,
        setFilterModalOpen,
        productToEdit,
        productToDelete,
        openCreateModal,
        openEditModal,
        openDeleteModal,
        closeModals
    };
};
